import i18n from '@/i18n/setup';

export const IMAGE_CLICK_ACTION_LIGHTBOX = 'lightbox';
export const IMAGE_CLICK_ACTION_LINK = 'link';
export const IMAGE_CLICK_ACTION_NONE = 'none';

export const IMAGE_CLICK_ACTION_LIGHTBOX_TITLE = i18n.t('builder.imageClickAction.action.lightbox');
export const IMAGE_CLICK_ACTION_LINK_TITLE = i18n.t('builder.imageClickAction.action.link');
export const IMAGE_CLICK_ACTION_NONE_TITLE = i18n.t('builder.imageClickAction.action.none');
